import { IEnvironment } from "./environment.interface";

export const environment: IEnvironment = {
  production: true,
  envName: 'prod',
  baseUrl: 'https://pulsewatch-api.facciobene.xyz',
  apiV1: 'api/v1/',
  uiDomain: 'https://pulsewatch-app.facciobene.xyz',
  apiDomain: 'https://pulsewatch-api.facciobene.xyz',

  firebase: {
    apiKey: "AIzaSyAezKJ8avQydTnYOlQovXS8TTDhOn_xqfU",
    authDomain: "pulsewatch-b03cd.firebaseapp.com",
    projectId: "pulsewatch-b03cd",
    storageBucket: "pulsewatch-b03cd.firebasestorage.app",
    messagingSenderId: "945686538615",
    appId: "1:945686538615:web:55e9276733ab8bca941972",
    measurementId: "G-FYHPLPND8F"
  },
};
